<template>
  <div class="route-viewer">
    <!-- <OperatHeader v-if="!isPlay">
      <div slot="left-action">
        <SearchInput></SearchInput>
      </div>
    </OperatHeader> -->
    <LeftDrawer v-if="!isPlay">
      <div class="leftdrawer-header ah" slot="header">
        <span>路径规划</span>
      </div>
      <!-- <div slot="body">
      <Empty></Empty>
    </div> -->
      <div class="ah" slot="body">
        <route-list
          class="ah"
          ref="rlist"
          :list="list"
          @click="clickRoute"
          @delete="deleteRoute"
          @play="playRoute"
        ></route-list>
      </div>
    </LeftDrawer>
    <RightDrawer ref="rightDrawer" :stopPropagation="true" v-if="!isPlay" :hiddenDrawer="permissionLevel <= PermissionLevel.LOOKER">
      <div class="rightdrawer-header" slot="header">
        <span>基础设置</span>
        <el-button type="primary" v-show="current && isSave" @click="saveRoute"
          >保存</el-button
        >
      </div>
      <div slot="body">
        <route-point-set
          :info="current"
          ref="rset"
          @change="isSave = true"
          v-if="current"
        ></route-point-set>
      </div>
    </RightDrawer>
    <route-play
      :info="currentPlay"
      @exit="exitPlayRoute"
      @showLine="onShowLine"
      v-if="isPlay"
    ></route-play>
    <!-- <ViewControler ref="viewControler"></ViewControler> -->
  </div>
</template>

<script>
import _ from 'lodash'
import * as turf from '@turf/turf'
import LeftDrawer from '@/components/Drawer/LeftDrawer'
import RightDrawer from '@/components/Drawer/RightDrawer'
import RouteList from './components/RouteList'
import RoutePointSet from './components/RoutePointSet'
import RoutePlay from './components/RoutePlay'
// import OperatHeader from '@/components/OperatHeader/OperatHeader'
// import SearchInput from './components/SearchInput'
import { mapGetters } from 'vuex'
import * as api from '@/api/route'
import { PermissionLevel } from '@/configs/constants'
export default {
  components: {
    LeftDrawer,
    RightDrawer,
    RouteList,
    RoutePointSet,
    RoutePlay
    // OperatHeader,
    // SearchInput
  },
  inject: ['cesiumViewer', 'shared'],
  data () {
    return {
      isSave: false,
      list: [],
      current: undefined,
      currentPlay: undefined,
      // 标记Id列表
      markers: [],
      loading: false,
      isPlay: false,
      PermissionLevel
    }
  },
  computed: {
    ...mapGetters(['isRightDrawVisible', 'userId', 'markerDatas', 'permissionLevel'])
  },
  methods: {
    customClickMarker (m) {
      if (!m) return
      if (!(m instanceof CesiumPlus.Marker)) {
        this.$Message('warning', '暂不支持API生成的标注点位')
        return
      }
      const { id } = m
      // 获取 mark 点标记
      const mark = _.chain(this.markerDatas)
        .filter((p) => /^point$/i.test(p.type))
        .map((p) => p.marks)
        .flatten()
        .find({ id })
        .value()
      if (mark) this.$refs.rset && this.$refs.rset.setMarker(mark)
    },
    async initRoutes () {
      const list = await api.getRoutes(this.mapId)
      this.list = list
    },
    /**
     * 命中保存
     * @param {Function} fn 保存回调方法
     * @param {Function} failure 还原或删除回调方法
     */
    async hitSave (fn, failure) {
      if (this.isSave) {
        let cancel = false
        this.isSave = false
        const { current } = this
        try {
          await this.$Submit({
            message: current.id
              ? '您修改了路径规划属性，是否保存？'
              : '您新建了路径规划，是否保存？',
            confirmButtonText: '保存',
            cancelButtonText: current.id ? '还原' : '删除'
          })
          this.isSave = true
        } catch (e) {
          cancel = true
        } finally {
          this.isSave = true
        }
        let result
        if (!cancel) {
          result = fn && fn()
        } else {
          result = failure && failure()
        }
        if (result instanceof Promise) {
          await result
        }
      }
    },
    /**
     * 点击指定路线
     */
    async clickRoute (route) {
      if (this.current !== route) {
        this.current = undefined
      }

      await this.$nextTick()
      await this.destroyRoute()

      let current
      // 存在路径规划对象时为
      if (route) {
        if (route.id) {
          current = await api.getRouteDetails(route.id)
          this.renderRoute(current)
        } else {
          current = route
        }
        this.$refs.rlist.select(route)
      } else {
        // 对象不存在Id时，代表的是新增数据
        this.list.splice(0, 0, {
          name: `路径规划${new Date().format('hhmm')}`
        })
        current = this.list[0]
        this.$refs.rlist.select(current)
        // 新建默认需要保存
        this.isSave = true
      }

      this.current = current
      this.$store.dispatch('showRight', true)
    },
    /**
     * 删除指定路线
     */
    async deleteRoute (route) {
      await this.$Delete()
      await api.delRoute(route.id)
      await this.initRoutes()
      if (this.current && route.id === this.current.id) {
        this.current = undefined
        this.$store.dispatch('showRight', false)
      } else {
        const entity = _.find(this.list, { id: this.current.id })
        if (entity) {
          this.clickRoute(entity)
        }
      }
      this.$message.success('操作成功')
    },
    /**
     * 播放路径规划
     */
    async playRoute (route) {
      this.isPlay = true
      this.$store.dispatch('showRight', false)
      await this.$nextTick()
      const model = await api.getRouteDetails(route.id)
      await this.destroyRoute()
      await this.renderRoute(model, false)
      this.currentPlay = model
    },
    /**
     * 播放路径规划
     */
    async exitPlayRoute () {
      await this.destroyRoute()
      await this.$nextTick()
      this.isPlay = false
      this.$store.dispatch('showRight', false)
    },
    // 渲染飞行路线
    async renderRoute (data, opacity = false) {
      // opacity 代表路线是否具备透明度
      const { pathType, marks, pathPlanning } = data
      let polyline = []
      switch (pathType) {
        case 'DRIVING':
        case 'WALKING':
          polyline = _.chain(pathPlanning.paths)
            .take(1)
            .map((p) => p.steps)
            .flatten()
            .map((p) => {
              return p.polyline
                .split(';')
                .map((str) => str.split(',').map((n) => Number(n)))
            })
            .flatten()
            .value()
          break
        default:
          polyline = _.chain(marks)
            .map(({ position }) => [position.lng, position.lat, position.alt])
            .value()
          break
      }
      if (polyline.length > 0) {
        this.$cesiumPlus.cameraManager.zoomToGeometry(turf.lineString(polyline), 0.5)
      }
      const material = opacity ? new Cesium.PolylineDashMaterialProperty({
        gapColor: Cesium.Color.fromCssColorString('#FFFFFF1A'),
        dashLength: 64,
        dashPattern: 0
      }) : new Cesium.PolylineDashMaterialProperty({
        gapColor: Cesium.Color.fromCssColorString('#06B03D'),
        dashLength: 64,
        dashPattern: 32
      })
      const layerId = 'route'
      const _polyline = await this.$cesiumPlus.markerManager.createMarker({
        layerId,
        polyline: {
          width: 5,
          clampToGround: pathType !== 'DRONE',
          material,
          positions: polyline
        }
      })
      this.markers.push(_polyline.id)
      marks.forEach(async (p, index) => {
        let src
        if (/^ORIGIN$/i.test(p.type)) {
          src = require('@/assets/images/route/start.png')
        } else if (/^DESTINATION$/i.test(p.type)) {
          src = require('@/assets/images/route/end.png')
        } else {
          src = require(`@/assets/images/route/road-${String.fromCharCode(
            96 + index
          )}.png`)
        }
        const m1 = await this.$cesiumPlus.markerManager.createMarker({
          layerId,
          name: p.markName,
          position: [p.position.lng, p.position.lat, p.position.alt],
          billboard: {
            show: true,
            pixelOffset: new Cesium.Cartesian2(12, -20)
          },
          style: [
            new CesiumPlus.BillboardStyle({
              image: src,
              show: true
            })
          ]
        })
        this.markers.push(m1.id)
      })

      if (pathType === 'DRONE') {
        // 渲染无人机飞行路线
      } else if (pathType === 'DRIVING') {
        // 渲染驾车路线
      } else if (pathType === 'WALKING') {
        // 渲染步行路线
      } else {
        // 未知
      }
    },
    // 销毁路线
    async destroyRoute () {
      this.markers.forEach((id) => {
        this.$cesiumPlus.markerManager.removeMarkerById(id)
      })
      this.markers.splice(0, this.markers.length)
    },
    // 保存线路
    async saveRoute () {
      const model = await this.$refs.rset.save()
      const { mapId } = this
      const res = await api.addOrUpdate({ mapId, ...model })
      const id = res.data || model.id
      // await this.destroyRoute()
      // await this.renderRoute(model)
      await this.initRoutes()
      this.isSave = false
      const entity = _.find(this.list, { id })
      if (entity) {
        this.clickRoute(entity)
      }

      this.$message.success('操作成功')
    },
    onShowLine (isShow) {
      const material = !isShow ? new Cesium.PolylineDashMaterialProperty({
        gapColor: Cesium.Color.fromCssColorString('#FFFFFF1A'),
        dashLength: 64,
        dashPattern: 0
      }) : new Cesium.PolylineDashMaterialProperty({
        gapColor: Cesium.Color.fromCssColorString('#06B03D'),
        dashLength: 64,
        dashPattern: 32
      })
      this.markers.forEach(id => {
        const marker = this.$cesiumPlus.markerManager.getMarkerById(id)
        if (marker && marker.entity.polyline) {
          marker.entity.polyline.material = material
          marker.entity.polyline.depthFailMaterial = material
        }
      })
    }
  },
  async mounted () {
    this.mapId = this.$route.query.mapId
    if (!this.mapId) {
      this.mapId = 0
    }
    this.cesiumViewer.customClickMarker = this.customClickMarker
    this.$store.dispatch('showLeft', true)
    this.$store.dispatch('showRight', false)

    // 初始化路径规划数据
    this.initRoutes()
    await this.$nextTick()
    window.onmousedown = this.hitSave.bind(this, async () => {
      await this.saveRoute()
      this.isSave = false
    }, async () => {
      const isAdd = !this.current.id
      if (isAdd) {
        this.current = undefined
        this.list.splice(0, 1)
        this.$store.dispatch('showRight', false)
      } else {
        const current = this.current
        this.current = undefined
        await this.$nextTick()
        this.current = await api.getRouteDetails(current.id)
      }
      this.isSave = false
    })
    this.$store.dispatch('setAllowDrawState', false)
  },
  beforeDestroy () {
    this.cesiumViewer.customClickMarker = undefined
    window.onmousedown = undefined
  },
  destroyed () {
    this.destroyRoute()
    this.$store.dispatch('setAllowDrawState', true)
  },
  filters: {}
}
</script>

<style lang="scss" scoped>
.leftdrawer-header {
  display: flex;
  align-items: center;
  padding-left: 13px;
}
.rightdrawer-header {
  display: flex;
  line-height: 40px;
  align-items: center;
  padding: 0px 12px;
  > :first-child {
    flex: 1;
    text-align: left;
  }
  > :last-child {
    width: 41px;
    height: 24px;
    font-size: 12px !important;
    padding: 0 5px !important;
  }
}
</style>
